<template>
  <div class="tiktokPage" id="video_box">
    <div class="video_user_card_mini" v-if="!showMore && !showList">
      <div class="first_row" style="background: rgb(13,13,13,0.5)">
        <div class="left_text">
          <div class="left_text_top">{{nickname}}</div>
          <div class="top_bar_title_bottom_company top_bar_title_bottom_company_more" v-if="title === '' && company_name === ''">暂无公司和职位</div>
          <div class="left_text_bottom" v-else>
            <div class="top_bar_title_bottom_job"> {{ title }}</div>
            <div class="top_bar_title_bottom_company">{{ company_name }}</div>
          </div>
        </div>
        <div class="right_icon">
          <div class="right_icon_link_div">
            <img class="right_icon_img" :src="require('/src/assets/icon/icon_link_round.png')" @click="linkWebsite()" v-show="company_website !== ''"/>
          </div>
          <div class="top_bar_right_care" :class="{ 'color_gray': isCare }" @click="toggleCare()">
            {{careText}}
          </div>
        </div>
      </div>
      <div class="second_row">
        <div class="clickArea" @click="changeShowMore">
          <van-icon name="arrow-down" color="#1EDF41" size="16px" /> <span>展开</span>
        </div>
      </div>
    </div>
<!--    展开视图-->
    <div class="video_user_card_large" v-if="showMore && !showList">

      <div class="second_row" style="padding: 12px 20px 0 20px;">


        <div class="first_row" style="padding: 0;background: none; backdrop-filter: none">
          <div class="left_text">
            <div class="left_text_top">{{nickname}}</div>
            <div class="top_bar_title_bottom_company top_bar_title_bottom_company_more" v-if="title === '' && company_name === ''">暂无公司和职位</div>
            <div class="left_text_bottom" v-else>
              <div class="top_bar_title_bottom_job"> {{ title }}</div>
              <div class="top_bar_title_bottom_company">{{ company_name }}</div>
            </div>
          </div>
          <div class="right_icon">
            <div class="right_icon_link_div">
              <img class="right_icon_img" :src="require('/src/assets/icon/icon_link_round.png')" @click="linkWebsite()" v-show="company_website !== ''"/>
            </div>
            <div class="top_bar_right_care" :class="{ 'color_gray': isCare }" @click="toggleCare()">
              {{ careText }}
            </div>
          </div>
        </div>



        <!-- 爱好 -->
        <div v-if="hobbies.length" class="aihao-item hx-flex-c-c hx-flex-j-s my_row card_bottom" style="margin-top: 0">
          <div class="ah-title">
          <span
            :style="{
              display: 'inline-block',
              width: '10px',
              height: '10px',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundImage: `url(${require('/src/assets/icon/ah.png')})`,
            }"
          ></span>
            爱好：
          </div>
          <div class="hx-text-ellipsis" style="flex: 1; font-size: 0">
        <span class="ah-tag" v-for="(item, index) in hobbies" :key="index">{{
            item
          }}</span>
          </div>
        </div>

        <!-- 标签 -->
        <div v-if="tags.length" class="aihao-item hx-flex-c-c hx-flex-j-s my_row card_bottom">
          <div class="ah-title bq-title">
        <span
          :style="{
            display: 'inline-block',
            width: '10px',
            height: '10px',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(${require('/src/assets/icon/bq.png')})`,
          }"
        ></span>
            标签：
          </div>
          <div class="hx-text-ellipsis" style="flex: 1; font-size: 0">
        <span
          class="ah-tag"
          :style="{
            background: selectColor(index),
          }"
          v-for="(item, index) in tags"
          :key="index"
        >{{ item }}</span>
          </div>
        </div>

        <div v-if="biography !== ''" class="aihao-item hx-flex-c-c hx-flex-j-s my_row card_bottom">
          <div class="myDesc">
            {{ biography }}
          </div>
        </div>
        <div class="aihao-item hx-flex-c-c hx-flex-j-s my_row card_bottom" style="display: flex;text-align: center;justify-content: center;margin-top: 0">
          <div class="clickArea" @click="changeShowMore">
            <van-icon name="arrow-up" color="#1EDF41" size="16px" /> <span>收起</span>
          </div>
        </div>
      </div>
    </div>
    <div class="abs_tiktok_back"
         @touchmove="handleTiktokTouchMoveBack"
         @touchstart="handleTouchStart"
         @touchend="handleTouchEnd"
         @click="handleBack"
         >
      <img width="50" height="335" :src="icon_turn_left"/>
    </div>

    <div class="abs_extend" @touchmove="handleTiktokTouchMoveBack" @click="changeThumbnailShow" v-if="!showList">
      <img width="28" height="28" :src="icon_expend"  />
    </div>


    <div style="width: 100vw;height: calc(100vh);">
      <!--vant van-swipe 滑动组件 -->
      <van-swipe
        ref="myVideoSwipe"
        v-show="!showList"
        :show-indicators="false"
        @change="onChange"
        vertical
        :loop="false"
        :activity="current"
        style="width: 100vw;height: calc(100vh - 83px);margin-top: 83px"
      >
        <van-swipe-item
          v-for="(item, index) in videoList"
          :key="index"
          class="video-item-swiper"
          style="width: 100vw;height: calc(100vh - 83px)"
        >
          <div class="user-video-container">
<!--            autoplay 才能触发onloadmetadata事件
@ended="onPlayerEnded($event)"
              :playOrPause="playOrPause"
-->
            <video
              :ref="'personVideo' + index"
              class="video_box"
              width="100%"
              height="100%"
              webkit-playsinline="true"
              x5-playsinline=""
              x5-video-player-type="h5"
              x5-video-player-fullscreen=""
              playsinline
              preload="auto"
              :poster="item.video_url + '?x-oss-process=video/snapshot,t_1,m_fast,f_jpg'"
              :src="item.video_url"
              x-webkit-airplay="allow"
              x5-video-orientation="portrait"
              @click="toggleVideoPlay"
              loop="loop"
              @loadedmetadata="() => {
                checkVideoOrientation(index)
              }"
              @pause="() => {
                sConsole('video on pause' )

              }"
              @play="() => {
                 sConsole('video on playing')
              }"
            ></video>
            <!-- 封面 -->
            <img
              :ref="'poster' + index"
              v-show="showCoverImage"
              class="img_cover"
              @click="playVideo"
              :src="item.video_url + '?x-oss-process=video/snapshot,t_1,m_fast,f_jpg'"
            />
            <!-- 播放暂停按钮 -->
            <img
              v-show="showPauseIcon"
              class="icon_play"
              @click="playVideo"
              :src="icon_play"
            />
          </div>
        </van-swipe-item>
      </van-swipe>
      <!--视频列表显示-->
      <div class="videoListBox" v-show="showList">
        <div class="video_user_card_large_bar" >
          <div class="first_row" style="background: black">
            <div class="left_text">
              <div class="left_text_top">{{nickname}}</div>
              <div class="top_bar_title_bottom_company top_bar_title_bottom_company_more" v-if="title === '' && company_name === ''">暂无公司和职位</div>
              <div class="left_text_bottom" v-else>
                <div class="top_bar_title_bottom_job"> {{ title }}</div>
                <div class="top_bar_title_bottom_company">{{ company_name }}</div>
              </div>
            </div>
            <div class="right_icon">
              <div class="right_icon_link_div">
                <img class="right_icon_img" :src="require('/src/assets/icon/icon_link_round.png')" @click="linkWebsite()" v-show="company_website !== ''"/>
              </div>
              <div class="top_bar_right_care" :class="{ 'color_gray': isCare }" @click="toggleCare()">
                {{careText}}
              </div>
            </div>
          </div>
          <div class="second_row" style="padding: 0 20px 5px 20px;background: black">

            <!-- 爱好 -->
            <div v-if="hobbies.length" class="aihao-item hx-flex-c-c hx-flex-j-s my_row card_bottom">
              <div class="ah-title">
              <span
                :style="{
                  display: 'inline-block',
                  width: '10px',
                  height: '10px',
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  backgroundImage: `url(${require('/src/assets/icon/ah.png')})`,
                }"
              ></span>
                爱好：
              </div>
              <div class="hx-text-ellipsis" style="flex: 1; font-size: 0">
        <span class="ah-tag" v-for="(item, index) in hobbies" :key="index">{{
            item
          }}</span>
              </div>
            </div>

            <!-- 标签 -->
            <div v-if="tags.length" class="aihao-item hx-flex-c-c hx-flex-j-s my_row card_bottom">
              <div class="ah-title bq-title">
        <span
          :style="{
            display: 'inline-block',
            width: '10px',
            height: '10px',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(${require('/src/assets/icon/bq.png')})`,
          }"
        ></span>
                标签：
              </div>
              <div class="hx-text-ellipsis" style="flex: 1; font-size: 0">
        <span
          class="ah-tag"
          :style="{
            background: selectColor(index),
          }"
          v-for="(item, index) in tags"
          :key="index"
        >{{ item }}</span>
              </div>
            </div>

            <div v-if="biography !== ''" class="aihao-item hx-flex-c-c hx-flex-j-s my_row card_bottom">
              <div class="myDesc">
                {{ biography }}
              </div>
            </div>
          </div>
        </div>
        <div class="video-list">
<!--          空视频列表提示-->
          <div class="empty_video_list" v-if="$store.state.vuex_userVideoInfo.length === 0">
            <div style="width: 100%;float: left">
              <img :src="emptyImg" width="213" height="152" style="background-size: cover">
            </div>
            <div style="width: 100%;float: left;display: flex;justify-content: center;margin-top: 16px;color: white;font-size: 15px;color: rgb(211, 211, 211)">
              空空如也
            </div>
            <div style="width: 100%;float: left;display: flex;justify-content: center;margin-top: 10px;font-size: 14px;color:rgb(146, 146, 146);">
              他/她还没上传视频
            </div>
          </div>

          <div v-for="(video, index) in videoList" :key="index" class="video-item" @click="playItemVideo(video, index)" v-else>
            <img :ref="'userVideoImg' + index" :src="video.video_url + '?x-oss-process=video/snapshot,t_1,m_fast,f_jpg'" alt="Video Thumbnail" class="thumbnail"
                 @load="setVideoSize(index)">
          </div>
        </div>
      </div>
    </div>

    <van-dialog class="dialog_care_dark" v-model="showCareDialog" :show-confirm-button="false">
      <div class="dialog_main_dark" >
        <div class="dialog_title_dark hx-flex-c-c hx-flex-j-b" style="padding-bottom: 8px">
          <div style="width: 100%;text-align: center">
          </div>
          <van-icon name="cross" @click="showCareDialog = false" color="white" />
        </div>
        <div class="dialog-content-custom1">
          <div class="text-care-love">
            <img  id="canvas_img" :src="miniQrCode"  width="160" height="160">
          </div>
          <div class="text-care-love" style="margin-top: 10px;color: white;line-height: 150%" v-show="sunSrc === ''">
            1.长按打开瞄呜AI智能体小程序<br>
            2.搜索框内粘贴他的昵称搜索<br>
            3.关注后就可以快速找到他啦<br>
          </div>
          <div class="text-care-love" style="margin-top: 10px;color: white;line-height: 150%" v-show="sunSrc !== ''">
            长按识别 进入瞄呜AI智能体小程序<br>
            关注后就可以快速找到他啦<br>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { follow, getSunImage, unfollow } from '@/api/app'
import Clipboard from 'clipboard'
const u = navigator.userAgent
export default {
  name: 'TiktokPage',
  components: {},
  props: {
    test: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      testLink: '2',
      showMore: false,
      current: 0,
      showList: false,// 是否展示视频列表
      showCoverImage: true,
      playOrPause: true,
      video: null,
      showPauseIcon: true,
      isAndroid: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1,
      isiOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      // icon_double_left: require('@/assets/icon/icon_round_left.png'),
      icon_turn_left: require('@/assets/img_turn_left.png'),
      icon_expend: require('@/assets/icon/icon_toggle.png'),
      icon_link_round: require('@/assets/icon/icon_link_round.png'),
      icon_play: require('@/assets/icon/icon_play_round.png'),
      bqBgMap: {
        0: 'rgba(30,223,65, 0.3)',
        1: 'rgba(224,32,32, 0.3)',
        2: 'rgba(0,145,255, 0.3)',
      },
      /* videoList: [
        {
          url: "https://awu-file.oss-cn-guangzhou.aliyuncs.com/mnt/data/facefusion/video/1715591346-18325042854-b3-speaking.mp4", // https://video.pearvideo.com/mp4/third/20201113/cont-1706821-15126082-111655-hd.mp4
          cover: "https://awu-file.oss-cn-guangzhou.aliyuncs.com/mnt/data/facefusion/video/1715591346-18325042854-b3-speaking.mp4?x-oss-process=video/snapshot,t_1,m_fast,f_jpg",
        },

        {
          url: "https://awu-file.oss-cn-guangzhou.aliyuncs.com/mnt/data/facefusion/video/1705721226-18682128689-12-speaking2.mp4",// https://video.pearvideo.com/mp4/third/20201111/cont-1706407-15488237-112532-hd.mp4
          cover: "https://awu-file.oss-cn-guangzhou.aliyuncs.com/mnt/data/facefusion/video/1705721226-18682128689-12-speaking2.mp4?x-oss-process=video/snapshot,t_1,m_fast,f_jpg",
        },
        {
          url: "https://awu-file.oss-cn-guangzhou.aliyuncs.com/mnt/data/facefusion/video/1705995801-18811111113-6-speaking2.mp4",// https://video.pearvideo.com/mp4/third/20201124/cont-1708555-15126082-104309-hd.mp4
          cover: "https://awu-file.oss-cn-guangzhou.aliyuncs.com/mnt/data/facefusion/video/1705995801-18811111113-6-speaking2.mp4?x-oss-process=video/snapshot,t_1,m_fast,f_jpg",
        }
      ] */
      videoList2: [
        {
          url: "https://video.pearvideo.com/mp4/third/20201113/cont-1706821-15126082-111655-hd.mp4",
          cover: "https://awu-file.oss-cn-guangzhou.aliyuncs.com/mnt/data/facefusion/video/1715591346-18325042854-b3-speaking.mp4?x-oss-process=video/snapshot,t_1,m_fast,f_jpg",
        },

        {
          url: "https://video.pearvideo.com/mp4/third/20201111/cont-1706407-15488237-112532-hd.mp4",
          cover: "https://awu-file.oss-cn-guangzhou.aliyuncs.com/mnt/data/facefusion/video/1705721226-18682128689-12-speaking2.mp4?x-oss-process=video/snapshot,t_1,m_fast,f_jpg",
        },
        {
          url: "https://video.pearvideo.com/mp4/third/20201124/cont-1708555-15126082-104309-hd.mp4",
          cover: "https://awu-file.oss-cn-guangzhou.aliyuncs.com/mnt/data/facefusion/video/1705995801-18811111113-6-speaking2.mp4?x-oss-process=video/snapshot,t_1,m_fast,f_jpg",
        }
      ],
      initialX: null,
      showCareDialog: false,
      sunSrc: '',
      miniQrCode: require('@/assets/miniqrcode.png'), // 小程序太阳码
      emptyImg: require('@/assets/img_empty2.png'),
    }
  },
  computed: {
    isCare() {
      return this.$store.state.appletInfo.isCare
    },
    user_token() {
      return this.$store.state.appletInfo.user_token
    },
    nickname() {
      return this.vuex_app_user_info?.nickname || '-'
    },
    videoList() {
      return this.$store.state.vuex_userVideoInfo
    },
    biography() {
      return this.vuex_app_user_info?.biography || "-"
    },
    title() {
      return this.vuex_app_user_info?.title || ''
    },
    company_name() {
      return this.vuex_app_user_info?.company_name || ''
    },
    hobbies() {
      return this.vuex_app_user_info?.hobbies || []
    },
    tags() {
      return this.vuex_app_user_info?.tags || []
    },
    careText(){
      return this.isCare ? '已关注' : '关注'
    },
    company_website(){
      return this.vuex_app_user_info?.company_website || ''
    },
  },
  mounted () {
    console.log('tikTok page mounted')
    if (this.videoList.length === 0){
      this.showList = true
    }
    if (this.videoList.length > 0){
      this.$refs.myVideoSwipe.swipeTo(this.current)
      if (this.isiOS) {
        // ios播放时重置显示封面。图标等
        this.showCoverImage = true
        this.showPauseIcon = true
      } else {
        // 安卓切换直接自动播放下一个
        this.playVideo()
      }
      // 统一不自动播放
      // this.showCoverImage = true
      // this.showPauseIcon = true

    }
  },
  methods: {
    sConsole(msg) {
      console.log(msg)
    },
    innerClick(event) {
      event.stopPropagation();
      console.log('Inner Div Clicked');
    },
    handleTouchStart(event) {
      this.initialX = event.touches[0].clientX
    },
    handleTouchEnd() {
      this.initialX = null
    },
    handleBack() {
      this.pauseCurrVideo()
      setTimeout(()=>{
        this.$emit('closeTikTok')
      }, 100)
    },
    handleTiktokTouchMoveBack() {
      /* const touch = event.touches[0];
      const distanceFromLeft = touch.clientX;
      console.log('distanceFromLeft', distanceFromLeft)
      if (distanceFromLeft > 100) {
        // 停止所有视频播放
        this.pauseCurrVideo()
        this.$emit('closeTikTok')
      } */
      if (this.initialX) {
        let currentX = event.touches[0].clientX;
        let deltaX = currentX - this.initialX;
        if (deltaX > 45) {
          console.log('触发条件')
          this.initialX = null
          // 停止所有视频播放
          this.pauseCurrVideo()
          setTimeout(()=>{
            this.$emit('closeTikTok')
          }, 100)
        }
      }
    },
    //滑动改变播放的视频
    onChange(index) {
      console.log('onchange index', index)

      //改变的时候 暂停当前播放的视频
      const refName = 'personVideo' + this.current
      const itemVideo = this.$refs[refName][0]
      itemVideo.pause()
      itemVideo.currentTime = 0


      this.current = index
      /* if (!this.isiOS) {
        // 安卓切换直接自动播放下一个
        this.showCoverImage = false
        this.playOrPause = true
        this.playVideo()
      } else {
        //ios播放时重置显示封面。图标等
        this.showCoverImage = true
        this.showPauseIcon = true
        this.playOrPause = false
      } */

      this.showCoverImage = false
      this.showPauseIcon = false
      this.playOrPause = true
      this.playVideo()

      if (index + 1 === this.videoList.length){
        this.$toast({
          message: '已经是最后一项了',
          position: 'bottom'
        })
      }
    },
    playVideo() {
      console.log('enter playVideo', this.current)
      const refName = 'personVideo' + this.current
      const itemVideo = this.$refs[refName][0]
      this.showCoverImage = false
      this.showPauseIcon = false
      this.playOrPause = true
      itemVideo.currentTime = 0
      setTimeout(()=>{
        itemVideo.play()
      },100)
      // window.onresize = function () {
      //   video.style.width = window.innerWidth + "px";
      //   video.style.height = window.innerHeight + "px";
      // };
    },
    playItemVideo(itemVideo, index){
      console.log('itemVideo click', index, itemVideo)
      this.showList = false
      // this.onChange(index)
      this.current = index
      this.$refs.myVideoSwipe.swipeTo(index) // 导致onchange触发 暂停

      setTimeout(()=>{
        this.playVideo()
      },50)
    },
    toggleVideoPlay() {
      //暂停\播放
      const refName = 'personVideo' + this.current
      const itemVideo = this.$refs[refName][0]

      if (this.playOrPause) {
        itemVideo.pause();
        this.showPauseIcon = true
      } else {
        itemVideo.play();
        this.showPauseIcon = false
      }
      this.playOrPause = !this.playOrPause;
    },
    pauseCurrVideo() {
      if (this.videoList.length > 0){
        console.log('enter pauseCurrVideo', this.current)
        //暂停\播放
        const refName = 'personVideo' + this.current
        const itemVideo = this.$refs[refName][0]
        itemVideo.pause()
        this.showPauseIcon = true
        this.playOrPause = false
      }
    },
    onPlayerEnded() {
      //视频结束
      this.showCoverImage = true
      this.current += this.current
    },
    //复制当前链接
    copyUrl() {
      Toast('复制链接成功')
      let httpUrl = window.location.href;
      var oInput = document.createElement("input");
      oInput.value = httpUrl;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
    },
    changeThumbnailShow(){
      this.pauseCurrVideo()
      this.showList = !this.showList
    },
    changeShowMore() {
      this.showMore = !this.showMore
      // this.testLink = this.testLink === '' ? '2' : ''
    },
    selectColor(index) {
      const i = index;
      const a = i % Object.keys(this.bqBgMap).length;
      // console.log("selectColor@@", a);
      return this.bqBgMap[a] || "";
    },
    linkWebsite() {
      if (!this.vuex_app_user_info?.company_website) {
        this.$myToast({
          type: "fail",
          message: "无链接地址",
        });
        return;
      }
      // location.href = this.vuex_app_user_info?.company_website;
      /* this.$myDialog({
        title: "网页跳转提示",
        message: this.vuex_app_user_info?.company_website,
        showCancelButton: true,
        confirmButtonText: "确认跳转",
        closeOnClickOverlay: true,
      }).then((result) => {
          location.href = this.vuex_app_user_info?.company_website;
      })
      .catch((err) => {}); */
      // 新需求 复制到粘贴板并提示已复制


      var oInput = document.createElement("input");
      oInput.value = this.vuex_app_user_info?.company_website + ''
      document.body.appendChild(oInput)
      oInput.select() // 选择对象
      document.execCommand("Copy") // 执行浏览器复制命令
      oInput.className = "oInput"
      oInput.style.display = "none"
      this.$toast('链接已复制，请粘贴到浏览器中查看吧')
    },
    showSunImage() {
      this.showCareDialog = true
      getSunImage(this.user_token).then( res => {
        if(res.status === 'ok'){
          const data = res.data
          this.sunSrc = data.qr_code
          // 解码base64数据为二进制数据
          let binaryData = atob(this.sunSrc);

          // 将二进制数据转换为Uint8Array
          let uint8Array = new Uint8Array(binaryData.length);
          for (let i = 0; i < binaryData.length; i++) {
            uint8Array[i] = binaryData.charCodeAt(i);
          }

          // 创建Blob对象
          let blob = new Blob([uint8Array], { type: 'image/png' }); // 假设图片类型为PNG

          // 创建Blob URL
          this.miniQrCode = URL.createObjectURL(blob);

        }
      }).catch( error => {
        // 处理请求错误
        console.log('获取太阳码失败稍后再试', error)
        this.$myToast({
          type: "fail",
          message: "获取太阳码失败稍后再试。 " + (error?.msg || error?.code)
        })
      })
    },
    toggleCare() {
      console.log('enter toggleCare')
      if (!this.$store.state.weiXinMark){
        this.showSunImage()
      } else {
        if (this.user_token === ''){
          this.$myToast({
            type: "fail",
            message: "无鉴权信息 user_token",
          })
          return
        }
        let isWillCare = !this.isCare

        const phone = this.$store.state?.vuex_app_user_info?.phone
        if (!phone || typeof phone === '' || typeof phone === 'undefined'){
          this.$myToast({
            type: "fail",
            message: "无分身信息手机号",
          })
          return
        }
        const params = {
          phone_num: phone
        }

        if (isWillCare){
          // 关注
          follow(params, this.user_token).then( res => {
            this.$store.commit('updateIsCareStatus', isWillCare)
            this.$myToast({
              message: "关注成功"
            })
          }).catch( error => {
            // 处理请求错误
            this.$store.commit('updateIsCareStatus', !isWillCare)
            console.log('关注失败稍后再试', error)
            this.$myToast({
              type: "fail",
              message: "关注失败稍后再试。 " + (error?.msg || error?.code)
            })
          })
        } else {
          // 取消关注
          unfollow(params, this.user_token).then( res => {
            this.$store.commit('updateIsCareStatus', isWillCare)
            this.$myToast({
              message: "取消关注"
            })
          }).catch( error => {
            // 处理请求错误
            this.$store.commit('updateIsCareStatus', !isWillCare)
            console.log('取关失败稍后再试')
            this.$myToast({
              type: "fail",
              message: "取消关注失败，请稍后再试。 " + (error?.msg || error?.code)
            })
          })
        }
      }

    },
    checkVideoOrientation (index) {
      const itemVideoName = 'personVideo' + index
      const itemVideo = this.$refs[itemVideoName][0]
      console.log('video index',index,' width:', itemVideo.videoWidth, ' height', itemVideo.videoHeight)
      if (itemVideo.videoWidth > itemVideo.videoHeight) {
        // 横屏视频
        console.log(index + '是横屏视频')
        itemVideo.style.width = '100%'
        itemVideo.style.height = 'auto'
        itemVideo.style.maxWidth = '100%'
        itemVideo.style.maxheight = '100%'
      } else {
        // 竖屏视频
        console.log(index + '是竖屏视频')
        itemVideo.style.width = 'auto' // 改为宽度也100%最好
        itemVideo.style.height = '100%' // 改为宽度也100%最好
        itemVideo.style.maxWidth = '100%'
        itemVideo.style.maxheight = '100%'
      }

      // 原文链接：https://blog.csdn.net/u010495529/article/details/86690024
      /* let canvas = document.createElement('canvas')
      canvas.width = itemVideo.videoWidth //loadeddata事件后，获取视频宽高妥妥的
      canvas.height = itemVideo.videoHeight
      canvas.getContext('2d').drawImage(itemVideo, 0, 0, canvas.width, canvas.height)
      let dataUrl = canvas.toDataURL('image/png')

      const itemPosterName = 'poster' + index
      const itemPoster = this.$refs[itemPosterName][0]
      itemPoster.src = dataUrl
      if( itemVideo.videoWidth > itemVideo.videoHeight ){
       /!*  itemPoster.style.height = '100%' *!/
        // itemPoster.style.width = 'auto'

        itemPoster.style.width = '100%';
        itemPoster.style.height = 'auto';
      }else {
        /!* itemPoster.style.width = '100%' *!/
        // itemPoster.style.height = 'auto'

        itemPoster.style.width = 'auto';
        itemPoster.style.height = '100%';
      }
      itemVideo.pause() */
    },
    setVideoSize(index) {
      // console.log('enter setVideoSize')
      // const itemVideoName = 'personVideo' + index
      // const itemVideo = this.$refs[itemVideoName][0]

    }

  }
}
</script>

<style scoped>
.aihao-item{
  box-sizing: border-box;
  margin-top: 12px;
}
.myDesc{
  width: 100%;
  color: white !important;;
  font-size: 14px;
  flex: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5; /* 设置最大行数 */
  overflow: hidden; /* 超出部分隐藏 */
}
.ah-title{
  font-size: 12px;
  color: #32c5ff;
  line-height: 1;
  padding: 3px 0;
}
.bq-title {
  color: #1edf41;
}
.ah-tag {
  box-sizing: border-box;
  display: inline-block;
  font-size: 12px;
  color: #fff !important;
  height: 20.4px;
  line-height: 20.4px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  padding: 1px 5px 2px 5px;
  margin: 0 2px;
  font-weight: 400;
}
.my_row{
  box-sizing: border-box;
  float: left;
  width: 100%;
}
</style>

<style scoped lang="less">
.tiktokPage{
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: rgb(37, 37, 37);
}
.abs_tiktok_back{
  position: absolute;
  width: 50px;
  height: 335px;
  left: 0;
  top: calc(50vh - 186px);
  z-index: 5;
  text-align: left;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

}
.abs_tiktok_test{
  position: absolute;
  width: 48px;
  height: 48px;
  left: 20px;
  top: 310px;
  z-index: 9999;
}
.abs_extend{
  width: 36px;
  height: 36px;
  text-align: center;
  position:absolute;
  right: 28px;
  bottom: 38px;
  z-index: 9999;
}
.video_user_card_mini{
  position: absolute;
  width: 100%;
  height: 86px;
  left: 0;
  top: 0;
  z-index: 9999;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
}


.video_user_card_large{
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 9999;
  .large_old_div{
    width: 100%;
    height: 62px;
    display: flex;
    padding: 0 5px;
    box-sizing: border-box;
  }
}

.first_row::before{
  backdrop-filter: blur(4px);
}

.first_row{
  float: left;
  display: flex;
  width: 100%;
  height: 60px;
  padding: 12px 20px 0 20px;
  box-sizing: border-box;
  background: rgba(13,13,13,0.5);
  // backdrop-filter: blur(4px);
// background: linear-gradient(to bottom, rgb(13, 13, 13, 1), rgb(33, 29, 26)); /* 从上到下渐变色 */
  .left_text{
    height: 47px;
    display: flex;
    flex: 1;
    flex-direction: column;
    font-family: PingFangSC, PingFang SC;
    .left_text_top{
      float: left;
      width: 100%;
      height: 22px;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
    }
    .left_text_bottom{
      float: left;
      width: 100%;
      height: 18px;
      text-align: left;
      font-style: normal;
      font-weight: 400;
      font-size: 10px;
      color: #FFFFFF;
      line-height: 14px;
      margin-top: 7px;
      .top_bar_title_bottom_job{
        float: left;
        height: 14px;
        line-height: 14px;
        max-width: 80px;
        padding: 2px 4px;
        margin-right: 6px;
        background: #383838;
        border-radius: 4px;
        text-align: center;
        // 超出内容省略号
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .top_bar_title_bottom_company{
      float: left;
      max-width: 120px;
      height: 14px;
      line-height: 14px;
      padding: 2px 4px;
      background: #383838;
      color: white;
      border-radius: 4px;
      text-align: center;
      // 超出内容省略号
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

    }
    .top_bar_title_bottom_company_more{
      max-width: 110px !important;
    }
  }
  .right_icon{
    display: flex;
    width: 110px;
    height: 47px;
    align-items: center;
    .right_icon_link_div{
      width: 28px;
      height: 28px;
      margin-right: 24px;
    }
    .right_icon_img{
      width: 28px;
      height: 28px;
    }
    .top_bar_right_care{
      float: right;
      width: 58px;
      height: 30px;
      background: #fe2c55;

      border-radius: 17px;
      line-height: 42px;

      display: flex;
      align-items: center;
      justify-content: center;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
      text-align: center;
      font-style: normal;
    }
  }
}
.second_row::before{
  backdrop-filter: blur(4px);
}
.second_row{
  float: left;
  width: 100%;
  box-sizing: border-box;
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
  background: rgba(13, 13, 13, 0.5);
  /*backdrop-filter: blur(4px);*/
  /*margin-top: -2px;*/
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .clickArea{
    width: 50px;
    height:18px;
    color: #1EDF41;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    font-style: normal;
    text-align: center;
    margin-top: 5px
  }
}


</style>
<!--爱好 标签-->

<style scoped>
.van_swipe {
  width: 100%;
  height: 100%;
}
.user-video-container{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #000000
}
.video_box {
  object-fit: cover !important;
  z-index: 999;
  width: 100%;
  height: 100%;
}
video {
  object-position: 0 0;
}
.img_cover{
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #010001; /*非常重要 用来覆盖显示不全的时候覆盖video的显示*/
}
.icon_play {
  position: absolute;
  top: 50%;
  left: 50%;
  bottom: auto;
  z-index: 999;
  height: 55px;
  /* background: rgba(0, 0, 0, 0.5); */
  transform: translate(-50%, -50%);
}
</style>

<style lang="less" scoped>
.videoListBox{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  .video_user_card_large_bar{
    float: left;
    width: 100%;
  }
  .video-list {
    width: 100%;
    float: left;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px; /* 设置视频项的上下和左右间隔为相同宽度 */
    padding: 12px 5px 0 5px;
    box-sizing: border-box;
  }
  .empty_video_list{
    position: absolute;
    width: 217px;
    padding: 94px 0 0 0;
    font-family: PingFangSC, PingFang SC;
    left: 50%;
    transform: translateX(-50%);
    top: 240px;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    text-align: left;
    font-style: normal;
  }
}


.video-item {
  //width: 50%;
  //padding: 10px;
  //box-sizing: border-box;
  cursor: pointer;
  display: flex;
  background: black;
  justify-content: center;
  align-items: center;
}

.thumbnail {
  width: 100%;
  //height: auto;
}
</style>

<style lang="less" scoped>
//关注弹窗
.dialog_care_dark{
  width: 80%;
  height: 318px;
  background: rgba(37, 37, 37, 1);
  color: white;
  font-size: 16px;
  margin: 0 auto;

  .text-care-love{
    float: left;
    width: 100%;
    color: rgba(174, 174, 174, 1);
    display: flex;
    justify-content: center;
    text-align: center;
  }
}
.dialog-content-custom1{
  width: 100%;
}
.dialog_main_dark {
  padding: 16px;
  color: white;
}
.dialog_title_dark {
  width: 100%;
  height: 32px;
  line-height: 1;
  padding-bottom: 16px;
  text-align: center;
}

.dialog-content-custom{
  width: 100%;
  height: calc(100vh - 64px);
  overflow: auto;
  .step_title_box{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 36px;
    .step_title{
      float: left;
      width: 246px;
      height: 28px;
      line-height: 28px;
      background-image: url("./../../../assets/stepLine.png");
      background-repeat: no-repeat;
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      margin: 0 auto;
      .step_title_left{
        float: left;
        width: 50px;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        margin-right: 10px;
      }
      .step_title_right{
        float: right;
        max-width: 190px;
        height: 25px;
        font-size: 16px;
        font-weight: 500;
        color: #FFFFFF;
        text-align: left;
      }
    }
  }


  .step_content{
    float: left;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    margin: 20px 0 12px 0;
    .download_div{
      float: left;
      width: 100%;
      height: 40px;
      margin-bottom: 12px;
      .download_btn{
        width: 134px !important;
        height: 38px !important;;
        background: #1edf41;
        border-radius: 5px;
        font-size: 18px;
        font-weight: 500;
        color: black;
      }
    }
    .download_tip{
      float: left;
      width: 100%;
      height: 20px;
    }
  }

  .img_poster_box{
    float: left;
    width: 100%;

    margin: 0 0 36px 0;
  }
}
</style>
